import styled from "styled-components";

export const Inner = styled.div``;
export const ValidatingMessage = styled.div``;
export const Title = styled.div``;
export const Result = styled.div``;
